var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTriangleStick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "50px",
    width: "49px",
    viewBox: "-10.82 14.937 75.686 71.3185",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -3.552713678800501e-15, -1.7763568394002505e-15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 34.654 42.176 L 34.213 42.026 C 34.057 41.974 32.133 41.875 32.073 42.009 L 15.802 77.419 C 15.643 77.669 14.504 78.473 13.928 78.529 C 13.555 78.566 12.948 78.834 11.688 78.876 C 9.537 78.944 8.116 79.162 8.116 79.162 C 8.116 79.162 7.394 79.937 7.432 80.495 C 7.473 81.053 7.655 81.541 7.655 81.541 C 7.655 81.541 8.271 82.236 8.839 82.26 C 9.192 82.275 11.527 82.199 13.62 81.95 C 14.901 81.798 16.309 81.677 16.902 81.376 C 18.003 80.815 19.518 79.656 19.701 79.263 L 35.989 43.808 C 36.05 43.674 34.808 42.228 34.654 42.176 Z",
    style: {
      fillRule: "nonzero"
    },
    transform: "matrix(0.914853036404, -0.403786987066, 0.403786987066, 0.914853036404, -23.253111448191, 13.998361031881)"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "rgb(216, 216, 216)",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 4
    },
    x1: 64.866,
    y1: 15.083,
    x2: 25.001,
    y2: 38.865
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "rgb(216, 216, 216)",
      stroke: "rgb(0, 0, 0)",
      transformBox: "fill-box",
      transformOrigin: "50% 50%",
      strokeWidth: 4
    },
    transform: "matrix(-1, 0, 0, -1, 0.000002, 0.000003)",
    points: "25.244 38.914 -0.113 22.055 -10.82 14.937"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleStick);
export default __webpack_public_path__ + "static/media/triangle-stick.359be3e7a6e3064124c2a80c368e59c9.svg";
export { ForwardRef as ReactComponent };